import { Drawer } from "antd";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import Close from "../../../../assets/images/close-x.svg";

const SMVirtualKeyboardDrawer = ({
  open,
  setOpen,
  showVirtualKeyboard,
  keyboard,
  layoutName,
  setLayoutName,
  inputName,
  updateKeyboardInputs,
  onKeyPress,
}) => {
  const onClose = () => {
    setOpen(false);
  };

  if (!open || !showVirtualKeyboard) return null;

  return (
    <Drawer
      placement="bottom"
      closable={false}
      styles={{ body: { paddingBottom: 0 } }}
      onClose={onClose}
      height="47vh"
      open={open && showVirtualKeyboard}
      mask={false}
    >
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "1vh" }}>
        <img
          src={Close}
          onClick={() => {
            setOpen(false);
            setLayoutName("default");
          }}
          style={{
            cursor: "pointer",
            width: "1.5vw",
          }}
        />
      </div>
      <div style={{ padding: "0 5vw" }}>
        <Keyboard
          keyboardRef={(r) => {
            keyboard.current = r;
          }}
          layoutName={layoutName}
          onChangeAll={(inputs) => {
            updateKeyboardInputs(inputs);
          }}
          onKeyPress={onKeyPress}
          inputName={inputName}
          display={{
            "{bksp}": "⌫",
            "{numbers}": "123",
            "{shift}": "⇧",
            "{enter}": "Enter",
            "{space}": "Space",
            "{number}": "123",
            "{caps}": "ABC",
            "{small}": "abc",
          }}
          layout={{
            shift: ["q w e r t y u i o p", "a s d f g h j k l", "{shift} z x c v b n m {bksp}", "{number} @ {space} . {enter}"],
            numbers: ["1 2 3 4 5 6 7 8 9 0", '- / : ; ( ) $ & @ "', "# . , _ ! ` {bksp}", "{caps} {space} {enter}"],
            number: ["1 2 3 4 5 6 7 8 9 0", '- / : ; ( ) $ & @ "', "# . , _ ! ` {bksp}", "{small} {space} {enter}"],
            default: ["Q W E R T Y U I O P", "A S D F G H J K L", "{shift} Z X C V B N M {bksp}", "{numbers} @ {space} . {enter}"],
          }}
        />
      </div>
    </Drawer>
  );
};

export default SMVirtualKeyboardDrawer;
